// components
import { Typography } from '@interstate/components/Typography';
import { Modal } from '@interstate/components/Modal';
import { Button } from '@interstate/components/Button';
import { FunctionsRowItem } from './FunctionsRowItem.interstate';

// styles
import { FunctionsFooterContainer, FunctionsRowContainer } from './Functions.style';

export interface IFunctionsModalProps {
    onHide(): void;
}

export const FunctionsModal = (props: IFunctionsModalProps) => {
    const { onHide } = props;

    const hotkeysMapping = {
        navigate: [
            { key: 'Next', value: 'Tab' },
            { key: 'Prev', value: 'Shift + Tab' }
        ],
        actions: [
            { key: 'Save', value: 'Alt + S' },
            { key: 'Buyer', value: 'Alt + BI' },
            { key: 'Co-Buyer', value: 'Alt + CI' }
        ],
        slideouts: [
            { key: 'Trade In', value: 'Alt + T' },
            { key: 'Fees', value: 'Alt + F' },
            { key: 'Taxes', value: 'Alt + X' },
            { key: 'Protection', value: 'Alt + P' },
            { key: 'Incentives', value: 'Alt + I' },
            { key: 'Lender', value: 'Alt + L' },
            { key: 'Accessories', value: 'Alt + A' }
        ]
    };

    const hotkeysDisplayConfig = [
        {
            row: [
                {
                    title: 'Navigate',
                    data: hotkeysMapping.navigate,
                    noMarginBottom: false
                },
                {
                    title: 'Actions',
                    data: hotkeysMapping.actions,
                    noMarginBottom: false
                }
            ]
        },
        {
            row: [
                {
                    title: 'Flyouts',
                    data: hotkeysMapping.slideouts.slice(0, 4),
                    noMarginBottom: true
                },
                {
                    title: '',
                    data: hotkeysMapping.slideouts.slice(4),
                    noMarginBottom: false
                }
            ]
        }
    ];

    const header = (
        <Typography variant="h3" color="sem.color.on-surface.default">
            Functions
        </Typography>
    );

    const footer = (
        <FunctionsFooterContainer>
            <Button size="md" className="functions-ok-button" data-testid="functions-ok-button" onClick={onHide}>
                Okay
            </Button>
        </FunctionsFooterContainer>
    );

    return (
        <Modal
            size="large"
            show={true}
            header={header}
            footer={{ footerComponent: footer }}
            onHide={onHide}
            data-testid="functions-modal"
        >
            {hotkeysDisplayConfig.map((item, index) => (
                <FunctionsRowContainer key={index} data-testid={`functions-modal-row-${index}`}>
                    {item.row.map((rowItem, rowIndex) => (
                        <FunctionsRowItem
                            key={rowIndex}
                            title={rowItem.title}
                            hotkeysData={rowItem.data}
                            showLeft={rowIndex === 0}
                            noMarginBottom={rowItem.noMarginBottom}
                            data-testid={`functions-modal-row-${index}-item-${rowIndex}`}
                        />
                    ))}
                </FunctionsRowContainer>
            ))}
        </Modal>
    );
};
